/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Connection
 */
export interface Connection  {
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof Connection
     */
    personId?: number;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    orcidId?: string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    orcidClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    accessToken?: string;
    /**
     * 
     * @type {number}
     * @memberof Connection
     */
    putCodeEmployment?: number;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    lastUpdateFromOrcid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Connection
     */
    publicUsageOfLimitedOrcidData?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Connection
     */
    orcidScopes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Connection
     */
    tokenRevoked?: boolean;
}

/**
 * Check if a given object implements the Connection interface.
 */
export function instanceOfConnection(value: object): value is Connection {
    return true;
}

export function ConnectionFromJSON(json: any): Connection {
    return ConnectionFromJSONTyped(json, false);
}

export function ConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Connection {
    if (json == null) {
        return json;
    }
    return {
        
                  'surname': json['surname'] == null ? undefined : json['surname'],
                  'givenname': json['givenname'] == null ? undefined : json['givenname'],
                  'email': json['email'] == null ? undefined : json['email'],
                  'personId': json['personId'] == null ? undefined : json['personId'],
                  'orcidId': json['orcidId'] == null ? undefined : json['orcidId'],
                  'orcidClientId': json['orcidClientId'] == null ? undefined : json['orcidClientId'],
                  'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
                  'putCodeEmployment': json['putCodeEmployment'] == null ? undefined : json['putCodeEmployment'],
                  'lastUpdateFromOrcid': json['lastUpdateFromOrcid'] == null ? undefined : json['lastUpdateFromOrcid'],
                  'publicUsageOfLimitedOrcidData': json['publicUsageOfLimitedOrcidData'] == null ? undefined : json['publicUsageOfLimitedOrcidData'],
              'orcidScopes': json['orcidScopes'] == null ? undefined : json['orcidScopes'],
                  'tokenRevoked': json['tokenRevoked'] == null ? undefined : json['tokenRevoked'],
    };
}

export function ConnectionToJSON(json: any): Connection {
    return ConnectionToJSONTyped(json, false);
}

export function ConnectionToJSONTyped(value?: Connection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'surname': value['surname'],
        'givenname': value['givenname'],
        'email': value['email'],
        'personId': value['personId'],
        'orcidId': value['orcidId'],
        'orcidClientId': value['orcidClientId'],
        'accessToken': value['accessToken'],
        'putCodeEmployment': value['putCodeEmployment'],
        'lastUpdateFromOrcid': value['lastUpdateFromOrcid'],
        'publicUsageOfLimitedOrcidData': value['publicUsageOfLimitedOrcidData'],
        'orcidScopes': value['orcidScopes'] == null? value['orcidScopes']: value['orcidScopes'],
        'tokenRevoked': value['tokenRevoked'],
    };
}


